import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const KNIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="KN" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#5EAA22"
        fillRule="evenodd"
        d="M0 0v12L16 0H0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#272727"
        stroke="#FFD018"
        strokeWidth={1.25}
        d="m16.719-1.928 2.66 2.968.481.537-.6.4L1.13 14.079l-.45.3-.362-.403-2.66-2.968-.481-.536.6-.4L15.906-2.03l.45-.301.362.403Z"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="m6.044 8.46-.544.947-.348-1.068-1.08-.343.9-.55-.108-1.117.889.684.92-.51-.258 1.136.74.85-1.11-.03ZM11.044 5.183l-.544.947-.348-1.067-1.08-.344.9-.55-.108-1.116.889.683.92-.51-.258 1.137.74.85-1.11-.03Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
